import mergeClasses from '../../../utils/shallowMerge';
import { Text } from '../../typography/text/Text';
import defaultClasses from './Swatches.module.scss';
import SwatchesItem from './SwatchesItem';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useMedia } from 'react-use';
import { swatchSize, theme } from './options';

const VISIBLE_QUANTITY = {
  narrow: 10,
  wide: 3,
  slider: 6,
  homeSlider: 4,
}

const Swatches = ({
  swatchesRef,
  colorIndex,
  swatchData,
  customClasses = '',
  className = '',
  isColorNameShown = true,
  gridType,
  tileRef,
}) => {

  const isMobile = useMedia('(max-width: 767px)', false);

  const getSwatchCount = () => {
    if (isMobile && gridType) {
      return VISIBLE_QUANTITY[gridType] || 5;
    }
    if (tileRef) {
      const tileWidth = tileRef?.current?.offsetWidth;
      return Math.trunc((tileWidth - 180) / swatchSize);
    }
    return 10;
  };

  const styles = mergeClasses(defaultClasses, customClasses);
  if (!swatchData) return null;

  const swatchesArr =
    gridType && tileRef ? swatchData.slice(0, getSwatchCount()) : swatchData;
  const transformedIndexText = () => {
    let index;
    const textIndex = `Colour: ${colorIndex}`;

    if (theme === 'Sportscraft') {
      index = textIndex
        .split(' ')
        .map((el) => el.slice(0, 1).toUpperCase() + el.slice(1).toLowerCase())
        .join(' ');
    } else {
      index = textIndex;
    }

    return index;
  };

  const swatchPosition = useMemo(() => {
    return (
      swatchesArr &&
      swatchesArr.findIndex((item) => {
        return item.colorAttribute === colorIndex;
      })
    );
  }, [colorIndex]);

  return (
    <div className={clsx(styles.wrapper, className)} ref={swatchesRef}>
      {isColorNameShown && (
        <Text
          className={`${styles.textIndex} ${styles.additionalStlye}`}
          size="xs"
          as="p"
        >
          {transformedIndexText()}
        </Text>
      )}
      <ul
        className={clsx(styles.colourContainer, {
          [styles.marginLeft]: swatchPosition === 0,
        })}
      >
        {swatchesArr.map(
          (item) =>
            !!item.imageUrl && (
              <SwatchesItem
                key={item?.id}
                imageUrl={item.imageUrl}
                colorAttribute={item.colorAttribute}
                url={item.url}
                colorIndex={colorIndex}
              />
            ),
        )}
        {swatchData.length - getSwatchCount() > 0 && gridType && (
          <span className={styles.restSwatchesCount}>
            {' '}
            +{swatchData.length - getSwatchCount()}
          </span>
        )}
      </ul>
    </div>
  );
};

Swatches.propTypes = {
  customClasses: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
};

export default Swatches;
